var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6641 16C21.7641 16 22.6641 15.1 22.6641 14C22.6641 12.9 21.7641 12 20.6641 12C19.5641 12 18.6641 12.9 18.6641 14C18.6641 15.1 19.5641 16 20.6641 16ZM20.6641 18C19.5641 18 18.6641 18.9 18.6641 20C18.6641 21.1 19.5641 22 20.6641 22C21.7641 22 22.6641 21.1 22.6641 20C22.6641 18.9 21.7641 18 20.6641 18ZM18.6641 26C18.6641 24.9 19.5641 24 20.6641 24C21.7641 24 22.6641 24.9 22.6641 26C22.6641 27.1 21.7641 28 20.6641 28C19.5641 28 18.6641 27.1 18.6641 26Z",
    fill: "#A3A9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.206bd9cac8d65e804d3d7fa54f9700e2.svg";
export { ForwardRef as ReactComponent };